export const DEFAULT_API_BASE_URL =
  import.meta.env?.VITE_API_BASE_URL?.trim() || "http://localhost:3000";

export const DEFAULT_TIMEZONE = "Asia/Kolkata";

export function normaliseBaseUrl(baseUrl) {
  return String(baseUrl || "").trim().replace(/\/+$/, "");
}
